"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseWindowContainerApi = /** @class */ (function () {
    function BaseWindowContainerApi() {
    }
    Object.defineProperty(BaseWindowContainerApi.prototype, "type", {
        get: function () {
            throw new Error("Not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseWindowContainerApi.prototype, "currentWindowName", {
        get: function () {
            return window.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseWindowContainerApi.prototype, "webSocketProtocol", {
        get: function () {
            return window.location.protocol === "https:" ? "wss:" : "ws:";
        },
        enumerable: true,
        configurable: true
    });
    BaseWindowContainerApi.prototype.subscribe = function (senderUuid, topic, listener) {
        return Promise.reject("Message subscription is not supported in " + this.type);
    };
    BaseWindowContainerApi.prototype.saveStringValue = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.localStorage.setItem(key, value);
                return [2 /*return*/];
            });
        });
    };
    BaseWindowContainerApi.prototype.loadStringValue = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, window.localStorage.getItem(key)];
            });
        });
    };
    BaseWindowContainerApi.prototype.clearStringValue = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.localStorage.removeItem(key);
                return [2 /*return*/];
            });
        });
    };
    return BaseWindowContainerApi;
}());
exports.BaseWindowContainerApi = BaseWindowContainerApi;



//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib/dist/business/base-window-container-api.js
// module id = 42
// module chunks = 0